const FALLBACK_APP_VERSION = '1.0.0'; // Bump this before build to force client updates if no env override is provided.
const FALLBACK_AUTO_UPDATE = false;

const envVersion = (import.meta.env.VITE_APP_VERSION as string | undefined)?.trim();
const envAutoUpdate = (import.meta.env.VITE_APP_AUTO_UPDATE as string | undefined)?.trim();

export const APP_VERSION = envVersion && envVersion.length > 0
  ? envVersion
  : FALLBACK_APP_VERSION;

export const AUTO_UPDATE_ON_VERSION_CHANGE = (envAutoUpdate ?? String(FALLBACK_AUTO_UPDATE))
  .toLowerCase() === 'true';
